export default "__VITE_ASSET__CLE5Z_lV__"